import { DatePicker, DatePickerProps } from '@sgi/gravity';
import { useControl } from '../../hooks/useControl';
import { ControlledProps, ControllerBaseProps } from '../../types';
import React from 'react';

export type FormDatePickerProps = Omit<DatePickerProps, ControlledProps> & {
  onChange?: DatePickerProps['onChange'];
  datePickerOptions?: DatePickerProps['datePickerOptions'];
  isClearable?: boolean;
} & ControllerBaseProps;

export const FormDatePicker = (props: FormDatePickerProps) => {
  const { error, field } = useControl({ name: props.name, deps: props.deps });
  return (
    <DatePicker
      {...props}
      error={error}
      {...field}
      onChange={e => {
        props.onChange?.(e);
        field.onChange(e);
        field.onBlur();
      }}
      datePickerOptions={{
        ...props?.datePickerOptions,
        onChangeRaw: e => {
          if (props.isClearable && e.target.type === 'text' && e.target.value === 'YYYY/MM/DD') {
            field.onChange('');
          }
        },
      }}
    />
  );
};
